import React from 'react';
import {useSelector} from "react-redux";

import {CUSTOM_LOGIC_DEMO, CUSTOM_LOGIC_MARYVALE, useCustomLogic} from "../../utils/customLogic";
import AdvancedList_Bulk_SelectAll from "../AdvancedList/AdvancedList_Bulk_SelectAll";
import AdmissionList_Header_ManagerCustomUI
    from "../AdmissionsList/Item/ManagerCustomUi/AdmissionList_Header_ManagerCustomUI";

const DischargeList_SortHeaders = ({_requestSort, _getClassNamesFor}) => {
    const {isCustomLogicHealtheCare,isCustomLogicLifehouse, isCustomLogicESPH, isCustomLogicDemo, isCustomLogicMaryvale} = useCustomLogic();
    const {selectedHospital} = useSelector(state => state.auth);
    const state_showDevUI = useSelector(state => state.auth.state_showDevUI);
    // Dev-only discharge survey status column: requires the hospital flag AND the dev UI toggle.
    const showSurveyDevUI = selectedHospital.manager_dischargeList_survey && state_showDevUI;
    // REFACTOR - use advancedList instead
    const {admissions, totalPages} = useSelector(state => state.admissionList);

    const sortingEnabled= (!totalPages) || (totalPages === 1)  || (totalPages === "1");

    const requestSort = _param => {
        if (sortingEnabled) {
            return _requestSort(_param)
        }
        return null;
    }
    const getClassNamesFor = _param => {
        if (sortingEnabled) {
            return _getClassNamesFor(_param)
        }
        return "no-sort";
    }

    const renderManagerDischargeListComments = () => {
        if (selectedHospital.manager_dischargeList_commentsEnable) {
            return (
                <th className={getClassNamesFor('discharge_comments_count')} onClick={() => requestSort('discharge_comments_count')}><strong className="title">Com</strong></th>
            )
        }
        return null;
    }
    const customUIHeader = pos => <AdmissionList_Header_ManagerCustomUI key={`custom${pos}`} position={pos} getClassNamesFor={getClassNamesFor} requestSort={requestSort} location={'LOCATION_TYPE_DISCHARGE_LIST'}/>

    switch (selectedHospital.hospitalConfig.customLogic)
    {
        case "CUSTOM_LOGIC_LIFEHOUSE":
        case CUSTOM_LOGIC_DEMO:
        case "CUSTOM_LOGIC_ESPH":
        case "CUSTOM_LOGIC_HEALTHECARE":
        case "CUSTOM_LOGIC_MARYVALE":
        default:
            return (
                <thead>
                <tr>
                    <th className="no-sort"><AdvancedList_Bulk_SelectAll /></th>
                    {customUIHeader(1)}
                    <th className={getClassNamesFor('surname')} onClick={() => requestSort('surname')}><strong className="title">Patient</strong></th>
                    {customUIHeader(2)}
                    {(isCustomLogicMaryvale() || isCustomLogicHealtheCare() || isCustomLogicESPH() || isCustomLogicDemo()) && <th className={getClassNamesFor('admittingDoctor')} onClick={() => requestSort('admittingDoctor')}><strong className="title">Surgeon</strong></th>}
                    {customUIHeader(3)}
                    <th className={getClassNamesFor('dischargeTime')} onClick={() => requestSort('dischargeTime')}><strong className="title">Dis. Time</strong></th>
                    {customUIHeader(4)}
                    {renderManagerDischargeListComments()}
                    {customUIHeader(5)}
                    {showSurveyDevUI && <th className="no-sort"><strong className="title">Survey</strong></th>}
                    <th className="no-sort" />
                </tr>
                </thead>
            );
    }

}

export default DischargeList_SortHeaders;